.root {
  width: 100%;
}

.root :global(.ReactCrop) {
  width: 100%;
  overflow: auto;
}

.root :global(.ReactCrop) img {
  width: 100%;
  height: auto;
}

.cropControls {
  width: 100%;
}

.tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 35px 0;
  width: 100%;
}

.previewContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: var(--gray-xl);
}

.previewContainer canvas {
  max-width: 120px;
  max-height: 120px;
}

.edit {
  display: flex;
  gap: 10px;
  align-items: center;
}

.scale {
  border: 2px solid var(--gray-l);
  border-radius: 4px;
  padding: 5px;
  width: 60px;
}

.aspect {
  height: 30px;
  width: 150px;
  background-color: var(--sec-01);
  border-radius: 4px;
  line-height: 30px;
}

.error {
  background-color: var(--error-bg, #fff3cd);
  color: var(--error-text, #856404);
  border: 1px solid var(--error-border, #ffeaa7);
  border-radius: 4px;
  padding: 10px;
  margin: 10px 0;
  font-family: var(--font-reg);
  font-size: 14px;
}

.preview {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: var(--gray-xl);
  margin: 20px 0;
}

.footer {
  text-align: center;
  margin-top: 25px;
}

.btn {
  width: 150px;
  border-radius: 4px;
  height: 40px;
  padding: 0;
}
